(function() {
  var qs = window.MidYearSaleUtils.qs;
  var qsa = window.MidYearSaleUtils.qsa;
  var addItems = window.MidYearSaleUtils.addItems;

  function setProcessing(button) {
    var spinnerColor = button.classList.contains('mys-btn--outline') ? '#0062C4' : '#FFFFFF';
    button.style.width = button.offsetWidth + 'px';
    button.classList.add('is-processing');
    button.setAttribute('aria-busy', 'true');
    button.innerHTML = window.MidYearSaleUtils.processingSpinnerHtml(spinnerColor);
  }

  function clearProcessing(button, html) {
    button.classList.remove('is-processing');
    button.removeAttribute('aria-busy');
    button.innerHTML = html;
    button.style.width = '';
  }

  function initProductActions(root) {
    root.addEventListener('click', function(event) {
      var addButton = event.target.closest('[data-mys-add-cart]');
      var buyButton = event.target.closest('[data-mys-buy-now]');
      var button = addButton || buyButton;
      if (!button || button.disabled) return;

      var variantId = Number(button.dataset.variantId);
      if (!variantId) return;
      event.preventDefault();

      var oldHtml = button.innerHTML;
      button.disabled = true;
      setProcessing(button);

      addItems([{ id: variantId, quantity: 1 }])
        .then(function() {
          if (buyButton) {
            window.location.href = '/checkout';
            return;
          }
          clearProcessing(button, oldHtml);
          button.textContent = button.dataset.added || 'Added';
          window.setTimeout(function() {
            button.innerHTML = oldHtml;
            button.disabled = false;
          }, 1200);
        })
        .catch(function(error) {
          clearProcessing(button, oldHtml);
          button.disabled = false;
          window.alert(error.message || 'Unable to add item.');
        });
    });
  }

  function initCoupon(root) {
    var coupon = qs(root, '[data-mys-coupon]');
    if (!coupon || coupon.dataset.mode === 'discount_code') return;
    var key = 'midYearSaleCouponClaimed';

    function claimed() {
      coupon.classList.add('is-claimed');
      var text = qs(coupon, '[data-mys-coupon-text]');
      if (text) {
        text.textContent = coupon.dataset.afterText || 'Congratulations! You have successfully claimed your 10% discount coupon, which will be automatically applied at checkout.';
      }
    }

    if (window.localStorage && localStorage.getItem(key) === 'true') claimed();

    coupon.addEventListener('click', function(event) {
      if (!event.target.closest('[data-mys-coupon-claim]')) return;
      if (window.localStorage) localStorage.setItem(key, 'true');
      claimed();
    });
  }

  function boot(root) {
    qsa(root, '[data-mid-year-top-picks]').forEach(function(section) {
      if (section.dataset.boundCoupon === 'true') return;
      section.dataset.boundCoupon = 'true';
      initCoupon(section);
      initProductActions(section);
    });
  }

  function init() {
    boot(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function(event) {
    if (!event.detail || !event.detail.sectionId) return;
    var section = document.getElementById('shopify-section-' + event.detail.sectionId);
    if (section) boot(section);
  });
})();
